/**
 * UserAvatar - Modern avatar component with fallback initials
 * Follows best practices for user avatar display
 */

function UserAvatar({ user, size = 'md' }) {
  const sizeMap = {
    sm: { width: '24px', height: '24px', fontSize: '10px' },
    md: { width: '32px', height: '32px', fontSize: '13px' },
    lg: { width: '40px', height: '40px', fontSize: '16px' }
  };

  const dimensions = sizeMap[size] || sizeMap.md;

  // Get user initials for fallback
  const getInitials = (user) => {
    if (user.name && user.name !== user.email) {
      return user.name
        .split(' ')
        .slice(0, 2)
        .map(n => n[0])
        .join('')
        .toUpperCase();
    }
    if (user.email) {
      return user.email[0].toUpperCase();
    }
    return 'U';
  };

  const initials = getInitials(user);

  // Style for fallback avatar (greyscale theme)
  const fallbackStyle = {
    width: dimensions.width,
    height: dimensions.height,
    borderRadius: '50%',
    backgroundColor: '#e5e7eb', // Light gray background
    color: '#374151', // Dark gray text
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: dimensions.fontSize,
    fontWeight: '600',
    userSelect: 'none',
    flexShrink: 0,
  };

  const imageStyle = {
    width: dimensions.width,
    height: dimensions.height,
    borderRadius: '50%',
    border: '2px solid #e5e7eb',
    objectFit: 'cover',
    flexShrink: 0,
  };

  // Use picture if available, otherwise show initials
  if (user.picture) {
    return (
      <img 
        src={user.picture} 
        alt={user.name || user.email || 'User'} 
        style={imageStyle}
        onError={(e) => {
          // If image fails to load, replace with fallback
          e.target.style.display = 'none';
          e.target.nextSibling.style.display = 'flex';
        }}
      />
    );
  }

  return <div style={fallbackStyle}>{initials}</div>;
}

export default UserAvatar;
